import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import { IngresosAlmacenApi } from "../api/IngresosAlmacenApi";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { IngresosTable } from "./IngresosTable";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import moment from "moment";

import Swal from "sweetalert2";
import { ConfirmacionTraslado } from "./ConfirmacionTraslado";
import { IngresosReprocesoTable } from "./IngresosReprocesoTable";
import { IngresosSobranteReprocesoTable } from "./IngresosSobranteReprocesoTable";
const alerta = require("assets/img/icons/alerta_roja.png");
const refreshIcon = require("assets/img/icons/refresh.png");

// soloLectura se usa al consultar el almacén de otro acopio: sin el handler de
// traslado, la tabla no ofrece la acción y el modal ni se monta
export const ListadoIngresos = ({
    regresar,
    almacenInventarioId,
    soloLectura,
}) => {
    const [detalleIngresos, setDetalleIngresos] = useState([]);

    const { getIngresosAlmacen, cargando } = IngresosAlmacenApi();

    const GetIngresosAlmacen = async () => {
        try {
            const response = await getIngresosAlmacen(almacenInventarioId);
            if (response) {
                setDetalleIngresos(response || []);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener ingresos disponibles",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setDetalleIngresos({});
        }
    };

    useEffect(() => {
        GetIngresosAlmacen();
    }, []);

    const [movimientoSeleccionado, setMovimientoSeleccionado] = useState(null);
    const almacenDetalle = detalleIngresos
        ? detalleIngresos.almacen_detalle
        : null;

    let tableContent = null;
    if (almacenDetalle && almacenDetalle.es_reproceso) {
        tableContent = (
            <React.Fragment>
                <h5 className="mt-4">Envíos por pallet</h5>
                <IngresosReprocesoTable
                    ingresos={detalleIngresos ? detalleIngresos.ingresos : []}
                />
                <h5 className="mt-4">Envíos por sobrantes</h5>
                <IngresosSobranteReprocesoTable
                    ingresosSobrante={
                        detalleIngresos ? detalleIngresos.ingresos_sobrante : []
                    }
                />
            </React.Fragment>
        );
    } else {
        tableContent = (
            <IngresosTable
                ingresos={detalleIngresos ? detalleIngresos.ingresos : []}
                total_kg_secos_lab={
                    detalleIngresos ? detalleIngresos.total_kg_secos_lab : 0
                }
                total_kg_secos_liq={
                    detalleIngresos ? detalleIngresos.total_kg_secos_liq : 0
                }
                total_kg_humedos={
                    detalleIngresos ? detalleIngresos.total_kg_humedos : 0
                }
                seleccionarIngreso={
                    soloLectura ? null : setMovimientoSeleccionado
                }
            />
        );
    }

    return (
        <div className="ingresos-almacen__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={cargando} blur>
                    <div className="ingresos-almacen__table-header">
                        <div className="formulario-field">
                            <label htmlFor="almacen" className="m-0">
                                Almacén
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={
                                    almacenDetalle ? almacenDetalle.nombre : ""
                                }
                                disabled
                            />
                        </div>
                        <div className="formulario-field">
                            <label htmlFor="fecha_inicial" className="m-0">
                                Fecha inicial
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={
                                    detalleIngresos.fecha_inicial
                                        ? moment(
                                              detalleIngresos.fecha_inicial,
                                          ).format("DD/MM/YYYY")
                                        : "N/A"
                                }
                                disabled
                            />
                        </div>
                        <div className="formulario-field">
                            <label htmlFor="fecha_final" className="m-0">
                                Fecha final
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={
                                    // restar un día a la fecha final para mostrar el rango correcto
                                    detalleIngresos.fecha_final
                                        ? moment(detalleIngresos.fecha_final)
                                              .subtract(1, "day")
                                              .format("DD/MM/YYYY")
                                        : "N/A"
                                }
                                disabled
                            />
                        </div>
                        <img
                            src={refreshIcon}
                            alt="Refrescar listado"
                            title="Refrescar listado"
                            className="action_img mb-1"
                            onClick={GetIngresosAlmacen}
                        />
                    </div>

                    {tableContent}

                    <div className="d-flex justify-content-center my-4 gap-1rem">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>
                    </div>
                </LoadMask>
            </CardEmpty>
            {!soloLectura && (
                <ConfirmacionTraslado
                    movimientoSeleccionado={movimientoSeleccionado}
                    onClose={() => setMovimientoSeleccionado(null)}
                    almacenOrigen={almacenDetalle}
                    onSuccess={GetIngresosAlmacen}
                />
            )}
        </div>
    );
};
